module.exports = __webpack_public_path__ + "static/media/thomas.0fd40e7d.jpg";